import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const heroImage =
  'https://readdy.ai/api/search-image?query=A%20vibrant%20flat%20lay%20of%20colorful%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20in%20a%20dynamic%20diagonal%20composition%20on%20a%20warm%20peach%20and%20cream%20background%20with%20an%20open%20central%20space%2C%20bright%20editorial%20e-commerce%20photography%2C%20soft%20natural%20light%2C%20rich%20warm%20color%20palette%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=usfans-hero&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[560px] items-center justify-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="USFans Spreadsheet products flat lay"
          title="USFans Spreadsheet products"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/35 via-background-50/10 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-primary-700">
          <i className="ri-sparkling-2-line"></i>
          {t('hero.badge')}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          {t('hero.title')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#categories"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 sm:w-auto"
          >
            {t('hero.ctaExplore')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600 sm:w-auto"
          >
            {t('hero.ctaBuy')}
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-primary-600"></i>
            {t('trust.independent')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line text-primary-600"></i>
            {t('trust.updated')}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-global-line text-primary-600"></i>
            {t('trust.multilingual')}
          </span>
        </div>
      </div>
    </section>
  );
}